import React from 'react';
import { Button, styled } from '@nextiva/next-ui-components';
import ErrorBoundary from './ErrorPage.tsx';
import styles from './ErrorBoundary.scss';

const StyledButton = styled(Button)`
  &.MuiButton-outlined.MuiButton-outlinedSecondary {
    color: #666666;
    border: 1px solid #cccccc;
    font-weight: 400;
  }
`;

const ErrorDialog = () => (
  <div className={styles.errorBlock}>
    <p>We&apos;re sorry — something&apos;s gone wrong.</p>
    <p>Our team has been notified</p>
    <br />
    <StyledButton variant="outlined" color="secondary">
      Report feedback
    </StyledButton>
  </div>
);

const ErrorBoundaryWrapper = ({ children }) => (
  <ErrorBoundary renderError={ErrorDialog}>{children}</ErrorBoundary>
);

export default ErrorBoundaryWrapper;
